import clsx from 'clsx';

export const RemoveButton = ({ onClick, hasValue }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!hasValue}
      aria-label="Wyczyść"
      className={clsx(
        'absolute top-[9px] right-[4px] flex items-center justify-center border-none bg-transparent p-0 px-0 cursor-pointer focus:outline-none',
        hasValue ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <svg
        className={clsx(
          'h-4 w-4 shrink-0 transition-transform duration-300 ease-in-out px-0',
          hasValue ? 'rotate-45' : 'rotate-0',
        )}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.0002 2C8.44202 2 8.8002 2.29848 8.8002 2.66667V13.3333C8.8002 13.7015 8.44202 14 8.0002 14C7.55837 14 7.2002 13.7015 7.2002 13.3333V2.66667C7.2002 2.29848 7.55837 2 8.0002 2Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 7.99995C2 7.55812 2.29848 7.19995 2.66667 7.19995H13.3333C13.7015 7.19995 14 7.55812 14 7.99995C14 8.44178 13.7015 8.79995 13.3333 8.79995H2.66667C2.29848 8.79995 2 8.44178 2 7.99995Z"
          fill="#F2F2F2"
        />
      </svg>
    </button>
  );
};

export default RemoveButton;
